import { makeStyles } from "tss-react/mui";

import { Theme } from "@mui/material";

export const useStyles = makeStyles()((theme: Theme) => ({
    container: {
        width: "100%",
        height: "100vh",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
    },
    button: {
        marginTop: theme.spacing(3),
    },
    dataStaleText: {
        maxWidth: 600,
        textAlign: "center",
    },
    root: {
        display: "flex",
        flexDirection: "column",
        minHeight: "100vh",
        width: "100%",
        flex: "1 1 0%",
    },
    content: {
        flex: 1,
        paddingTop: theme.spacing(8),
        paddingBottom: theme.spacing(4),
        paddingLeft: theme.spacing(2),
        paddingRight: theme.spacing(2),
    },
    formWrapper: {
        maxWidth: 680,
        width: "100%",
        margin: "0 auto",
    },
    header: {
        display: "flex",
        alignItems: "center",
        justifyContent: "flex-start",
        width: "100%",
        minHeight: 72,
        paddingTop: theme.spacing(2),
        paddingBottom: theme.spacing(2),
        paddingLeft: theme.spacing(2),
        paddingRight: theme.spacing(2),
        backgroundColor: theme.palette.background.paper,
        borderBottom: `1px solid ${theme.palette.divider}`,
    },
    logoBox: {
        display: "flex",
        alignItems: "center",
        marginLeft: theme.spacing(6),
    },
    logoLink: {
        display: "flex",
        alignItems: "center",
    },
    logoImg: {
        display: "block",
    },
    sectionTitle: {
        fontSize: 12,
        textTransform: "uppercase",
        color: theme.palette.text.secondary,
        fontWeight: 600,
        marginBottom: theme.spacing(2),
    },
    sectionSpacing: {
        marginTop: theme.spacing(4),
    },
    row: {
        display: "flex",
        alignItems: "flex-start",
        marginBottom: theme.spacing(2),
    },
    requiredLabel: {
        paddingTop: 0,
        "&::after": {
            content: "\"*\"",
            color: theme.palette.emteria.error,
            marginLeft: "0.25rem",
        },
    },
    footer: {
        display: "flex",
        flexDirection: "column",
        paddingTop: theme.spacing(2),
        gap: theme.spacing(1),
    },
    agreeBox: {
        "& .MuiFormControlLabel-root": {
            alignItems: "flex-start",
            maxWidth: "100%",
        },
        "& .MuiFormControlLabel-label": {
            whiteSpace: "nowrap",
            overflow: "visible",
        },
    },
    confirmRegistrationContainer: {
        marginTop: "2rem",
        marginBottom: "2rem",
        width: "100%",
    },
}));
